// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2hT2C","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1PbTR"};